import { Fragment } from "react";

export interface ShortcutItem { keys: string[]; or?: string[]; does: string; }
export interface ShortcutGroupData { id: string; title: string; where: string; items: ShortcutItem[]; }

/** One key cap. Keys pressed together sit side by side; "or" separates a second way. */
export function Kbd({ children }: { children: string }) { return <kbd className="ob-keycap">{children}</kbd>; }

const Combo = ({ keys }: { keys: string[] }) => <span className="ob-shortcuts__combo">{keys.map((k, i) => <Kbd key={i}>{k}</Kbd>)}</span>;

/** The keyboard sheet: groups by where a shortcut works, each row the keys and what they do. */
export function ShortcutSheet({ groups }: { groups: ShortcutGroupData[] }) {
  return (
    <div className="ob-shortcuts">
      {groups.map((g) => (
        <section key={g.id} className="ob-shortcuts__group" aria-labelledby={`shortcuts-${g.id}`}>
          <h3 className="ob-shortcuts__title" id={`shortcuts-${g.id}`}>{g.title}<span className="ob-shortcuts__where">{g.where}</span></h3>
          <dl className="ob-shortcuts__list">
            {g.items.map((it, i) => (
              <Fragment key={i}>
                <dt className="ob-shortcuts__keys"><Combo keys={it.keys} />{it.or && <><span className="ob-shortcuts__or">or</span><Combo keys={it.or} /></>}</dt>
                <dd className="ob-shortcuts__does">{it.does}</dd>
              </Fragment>
            ))}
          </dl>
        </section>
      ))}
    </div>
  );
}
